module.exports = __webpack_public_path__ + "img/-LV4tMiWP-XoCq9nRFya.914abf07.jpg";